import { render } from "./SetAuctionPanel.vue?vue&type=template&id=47d05022&scoped=true"
import script from "./SetAuctionPanel.vue?vue&type=script&lang=js"
export * from "./SetAuctionPanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/auctionModal.scss?vue&type=style&index=0&id=47d05022&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d05022"]])

export default __exports__